export const OrderReviewProcessStep = {
  Appointment: {
    nextStep: 'Appointment',
    nextViewPage: 'appointment.html',
    currentStep: 'ReviewOrder',
    previousStep: 'Tos',
  },
  Confirmation: {
    nextStep: 'Confirmation',
    nextViewPage: 'confirmation.html',
    currentStep: 'ReviewOrder',
    previousStep: 'Tos',
  },
  Registration: {
    nextStep: 'Registration',
    nextViewPage: 'registration.html',
    currentStep: 'ReviewOrder',
    previousStep: 'Tos',
  },
  Payment: {
    nextStep: 'Payment',
    nextViewPage: 'payment.html',
    currentStep: 'ReviewOrder',
  },
};

export const ExpressTosProcessStep = {
  Confirmation: {
    nextStep: 'Confirmation',
    nextViewPage: 'confirmation.html',
    currentStep: 'ExpressTOS',
    previousStep: 'ExpressCheckout',
  },
  Payment: {
    nextStep: 'Payment',
    nextViewPage: 'payment.html',
    currentStep: 'ExpressTOS',
  },
  Appointment: {
    nextStep: 'Appointment',
    nextViewPage: 'appointment.html',
    currentStep: 'ExpressTOS',
    previousStep: 'ExpressCheckout',
  },
  Registration: {
    nextStep: 'Registration',
    nextViewPage: 'registration.html',
    currentStep: 'ExpressTOS',
    previousStep: 'ExpressCheckout',
  },
};

export const ExpressCheckoutProcessStep = {
  nextStep: 'ExpressTOS',
  nextViewPage: 'expresstos.html',
  currentStep: 'ExpressCheckout',
  previousStep: 'Setup',
  editSetupPage: 'setup.html',
  editAddonsPage: 'addons.html',
  editAddonsStep: 'addons.html',
  editPage: 'addons.html',
  editPlansPage: 'progressiveplan.html',
  editPlansStep: 'PlansOverview',
  FiveG: {
    nextStep: 'TermandCondition',
    nextViewPage: 'appointment.html',
    currentStep: 'ExpressCheckout',
    previousStep: 'ExpressCheckout',
  },
  LTE: {
    nextStep: 'Confirmation',
    nextViewPage: 'confirmation.html',
    currentStep: 'termandCondition',
    previousStep: 'ExpressCheckout',
  },
  Payment: {
    nextStep: 'Payment',
    nextViewPage: 'payment.html',
    currentStep: 'ExpressCheckout',
    previousStep: 'Addons',
  },
  Shipping: {
    nextStep: 'Shipping',
    nextViewPage: 'shipping.html',
    currentStep: 'ExpressCheckout',
    previousStep: 'Addons',
  },
  ContactInfo: {
    nextStep: 'ContactInfo',
    nextViewPage: 'contactinfo.html',
    currentStep: 'ExpressCheckout',
    previousStep: 'Addons',
  },
  ExpressTOS: {
    nextStep: 'ExpressTOS',
    nextViewPage: 'expresstos.html',
    currentStep: 'ExpressCheckout',
    previousStep: 'Addons',
  },
  Appointment: {
    nextStep: 'Appointment',
    nextViewPage: 'appointment.html',
    currentStep: 'ExpressCheckout',
    previousStep: 'Addons',
  },
  CreditStatus: {
    nextStep: 'CreditStatus',
    nextViewPage: 'creditstatus.html',
    currentStep: 'ExpressCheckout',
    previousStep: 'Addons',
  },
};

export const RegistrationProcessStep = {
  Confirmation: {
    nextStep: 'Confirmation',
    nextViewPage: 'confirmation.html',
    currentStep: 'Registration',
    previousStep: 'Appointment',
  },
};

export const ContactInfoProcessStep = {
  PREORDER: {
    nextStep: 'OrderReview',
    nextViewPage: 'orderreview.html',
    currentStep: 'ContactInfo',
    previousStep: 'Cart',
  },
  SELF: {
    nextStep: 'Shipping',
    nextViewPage: 'shipping.html',
    currentStep: 'ContactInfo',
    previousStep: 'Cart',
  },
  Shipping: {
    nextStep: 'Shipping',
    nextViewPage: 'shipping.html',
    currentStep: 'ContactInfo',
    previousStep: 'Cart',
  },
  PRO: {
    Payment: {
      nextStep: 'Payment',
      nextViewPage: 'payment.html',
      currentStep: 'ContactInfo',
      previousStep: 'Cart',
    },
    Tos: {
      nextStep: 'Tos',
      nextViewPage: 'tos.html',
      currentStep: 'ContactInfo',
      previousStep: 'Cart',
    },
    OrderReview: {
      nextStep: 'OrderReview',
      nextViewPage: 'orderreview.html',
      currentStep: 'ContactInfo',
      previousStep: 'Cart',
    },
  },
  SendLink: {
    nextStep: 'SendLink',
    nextViewPage: 'sendlink.html',
    currentStep: 'ContactInfo',
    previousStep: 'Cart',
  },
  CreditStatus: {
    nextStep: 'CreditStatus',
    nextViewPage: 'creditstatus.html',
    currentStep: 'ContactInfo',
    previousStep: 'Cart',
  },
  CreditCheck: {
    nextStep: 'CreditCheck',
    nextViewPage: 'creditcheck.html',
    currentStep: 'ContactInfo',
    previousStep: 'Cart',
  },
  Payment: {
    nextStep: 'Payment',
    nextViewPage: 'payment.html',
    currentStep: 'Shipping',
    previousStep: 'ContactInfo',
  },
  OrderReview: {
    nextStep: 'OrderReview',
    nextViewPage: 'orderreview.html',
    currentStep: 'Shipping',
    previousStep: 'ContactInfo',
  },
  ExpressCheckout: {
    nextStep: 'ExpressCheckout',
    nextViewPage: 'expresscheckout.html',
    currentStep: 'ContactInfo',
    previousStep: 'Addons',
  },
};

export const CreditCheckProcessStep = {
  CreditSuccess: {
    nextStep: 'CreditStatus',
    nextViewPage: 'creditstatus.html',
    currentStep: 'CreditCheck',
    previousStep: 'ContactInfo',
  },
  ExpressCart: {
    nextStep: 'ExpressCart',
    nextViewPage: 'expresscart.html?NoBundle=Y',
    currentStep: 'CreditCheck',
    previousStep: 'ContactInfo',
  },
  OrderReview: {
    nextStep: 'OrderReview',
    nextViewPage: 'orderreview.html',
    currentStep: 'CreditCheck',
    previousStep: 'ContactInfo',
  },
  Payment: {
    nextStep: 'Payment',
    nextViewPage: 'payment.html',
    currentStep: 'CreditCheck',
    previousStep: 'ContactInfo',
  },
  ExpressCheckout: {
    nextStep: 'ExpressCheckout',
    nextViewPage: 'expresscheckout.html',
    currentStep: 'CreditCheck',
    previousStep: 'ContactInfo',
  },
  CreditHold: {
    nextStep: 'CreditHold',
    nextViewPage: 'creditstatus.html',
    currentStep: 'CreditCheck',
    previousStep: 'ContactInfo',
  },
  d2dEidSuccess: {
    nextStep: 'EidStatus',
    nextViewPage: 'eidstatus.html',
    currentStep: 'CreditCheck',
    previousStep: 'CreditCheck',
  },
  D2dBackEidSuccess: {
    nextStep: 'SendLink',
    nextViewPage: 'sendlink.html',
    currentStep: 'EidStatus',
    previousStep: 'CreditCheck',
  },
  EdgeIneligible: {
    nextStep: 'CreditEdgeInEligible',
    nextViewPage: 'creditedgeInEligible.html',
    currentStep: 'CreditCheck',
    previousStep: 'CreditCheck',
  },
  CreditDownPayment: {
    nextStep: 'DownPayment',
    nextViewPage: 'downpayment.html',
    currentStep: 'CreditCheck',
    previousStep: 'ContactInfo',
  },
  TosPage: {
    nextStep: 'TOS',
    nextViewPage: 'tos.html',
    currentStep: 'CreditCheck',
    previousStep: 'ContactInfo',
  },
};